import React from 'react'
import AdListCol1FilterAndDetails from '../COMPONENT/adListcol1FilterAndDetails'
import Header from '../COMPONENT/header'
import SideBar from '../COMPONENT/sideBar'
import MobileNav from '../COMPONENT/mobileNav'
import Footer from '../COMPONENT/footer'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

export default function AdListColumn1(e,x) {

  return (
    <div>

      <Header/>
      <SideBar/>
      <MobileNav/>

      <section class="inner-section single-banner">
         <div class="container">
            <div class="row">
               <div class="col-lg-12">
                  <div class="single-content">
                     <h2>ad List column 1</h2>
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">ad-list-column1</li>
                     </ol>
                  </div>
               </div>
            </div>
         </div>
      </section>
    
      <AdListCol1FilterAndDetails {...x}/>
      <Footer/>

      <Helmet>
    <script type="media_type" src="../js/vendor/jquery-1.12.4.min.js"></script>
    <script type="media_type" src="../js/vendor/popper.min.js"></script>
    <script type="media_type" src="../js/vendor/bootstrap.min.js"></script>
    <script type="media_type"src="../js/custom/main.js"></script>
    <script type="media_type"src="../js/vendor/slick.min.js"></script>
    <script type="media_type"src="../js/custom/slick.js"></script>
    </Helmet>
    </div>
  )
}
